<template>
    <div
        class="number-img"
        :class="numClass"
        :style="numStyle"
    >
        {{ imgUrl ? '' : numberText }}
    </div>
</template>
<script>
import Const from '@/pages/pano-game/constant/Constant';

export default {
    props: {
        numberText: {
            type: String,
            default: ''
        },
        numberColor: {
            type: String,
            default: 'white'
        }
    },
    computed: {
        imgUrl() {
            return Const.specialFontImgs[this.numberColor][this.numberText];
        },
        numClass() {
            const num = [this.numberColor];
            if (this.numberText === '-') {
                num.push('line');
            }
            else if (this.numberText === '1') {
                num.push('one');
            }
            // 识别单位前的空格
            else if (this.numberText === ' ') {
                num.push('none-text');
            }
            return num;
        },
        numStyle() {
            const style = {};
            if (this.imgUrl) {
                style.backgroundImage = `url(${this.imgUrl})`;
            }
            else if (this.numberText !== ' ') {
                style.width = 'auto';
            }
            return style;
        }
    }
};
</script>
<style lang='scss' scoped>
.number-img {
    display: inline-block;
    width: 13px;
    height: 12px;
    background-position: right center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    &.line {
        width: 13px;
        height: 5px;
    }
    &.italic {
        width: 6px;
        height: 9px;
        background-size: 100% 100%;
        background-position: center bottom;
    }
    &.none-text {
        width: 2px;
    }
}
</style>